import React from 'react'
import { Image, ImageSourcePropType, View } from 'react-native'
import { ATLButton, ATLTextBody, ButtonTypeEnum, FontWeightEnum, ATLAtomIcon } from '@appsimples/atlantica-react-native'
import { atlTheme } from '../../../atlTheme'
import styled from 'styled-components/native'

const ComponentContainer = styled.View`
  flex-direction: row;
  align-items: center;
  padding-horizontal: ${atlTheme.SpacingMarginal}px;
  margin-vertical: ${atlTheme.SpacingBase}px;
`

const TitleContainer = styled.View`
  flex-direction: row;
  align-items: center;
  padding-right: ${atlTheme.SpacingDistribute}px;
  justify-content: space-between;
  width: 100%;
`

const ButtonContainer = styled.View`
  width: 30%;
`

export interface IconTwoTextProps {
  icon?: ImageSourcePropType
  button?: boolean
  buttonType?: ButtonTypeEnum
  firstTextVertical?: string
  secondTextVertical?: string
  buttonTitle?: string
  onPress?: any
  twoText?: boolean
  firstTextHorizontal?: string
  secondTextHorizontal?: string
}
export const IconTwoText: React.FunctionComponent<IconTwoTextProps> = ({
  icon,
  buttonType,
  button,
  firstTextVertical,
  secondTextVertical,
  buttonTitle,
  onPress,
  twoText,
  firstTextHorizontal,
  secondTextHorizontal,
}) => {
  return (
    <ComponentContainer>
      {icon && <ATLAtomIcon source={icon} />}
      <TitleContainer>
        {twoText ? (
          <View>
            <ATLTextBody
              horizontalMargin={atlTheme.SpacingBase}
              verticalMargin={0.1}
              labelBaseProps={{
                multilineLimit: 1,
                textColor: atlTheme.ColorMediumContrast,
                fontSize: atlTheme.FontSizeAuxiliary,
              }}
            >
              {firstTextVertical}
            </ATLTextBody>
            <ATLTextBody
              horizontalMargin={atlTheme.SpacingBase}
              verticalMargin={0.1}
              labelBaseProps={{ multilineLimit: 1 }}
            >
              {secondTextVertical}
            </ATLTextBody>
          </View>
        ) : (
          <ATLTextBody
            horizontalMargin={atlTheme.SpacingBase}
            verticalMargin={0.1}
            labelBaseProps={{
              multilineLimit: 1,
              textColor: atlTheme.ColorHighContrast,
              fontSize: atlTheme.FontSizeBody,
              fontWeight: FontWeightEnum.medium,
            }}
          >
            {firstTextHorizontal}
          </ATLTextBody>
        )}
        {button ? (
          <ButtonContainer>
            <ATLButton
              verticalMargin={0.1}
              horizontalMargin={0.1}
              title={buttonTitle}
              onPress={onPress}
              buttonBaseProps={{ borderRadius: atlTheme.BorderRadiusFloatingButton, fontWeight: FontWeightEnum.medium }}
              type={buttonType}
            />
          </ButtonContainer>
        ) : (
          <ATLTextBody
            horizontalMargin={0.1}
            labelBaseProps={{ multilineLimit: 1, textColor: atlTheme.ColorMediumContrast }}
          >
            {secondTextHorizontal}
          </ATLTextBody>
        )}
      </TitleContainer>
    </ComponentContainer>
  )
}
